import { setStepIndex, stopTour } from "../redux/globalJoyrideSlice";


export const JoyrideContent = ({ en, hi }) => {
    const isMobile = window.innerWidth <= 768;
    return (
        <div>
            <div style={{ fontWeight: 500, fontSize: isMobile ? "13px" : "inherit", lineHeight: isMobile ? "1.3" : "inherit" }}>{en}</div>
            <div
                style={{ fontWeight: 500, marginTop: isMobile ? "2px" : "4px", fontSize: isMobile ? "12px" : "inherit", lineHeight: isMobile ? "1.3" : "inherit" }}
            >
                {hi}
            </div>
        </div>
    );
};

export const getAcademicCalendarTourSteps = () => [
        {
            target: '[data-tour="add-session"]',
            content: (
                <JoyrideContent
                    en="Click here to create and a new Academic Session."
                    hi="अपना नया अकादमिक सत्र शुरू करने के लिए यहाँ क्लिक करें।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
            spotlightClicks: true,
            hideFooter: true,
        },
        {
            target: '[data-tour="session-start-date"]',
            content: (
                <JoyrideContent
                    en="Enter the Academic Session start date."
                    hi="सत्र प्रारंभ होने की तिथि बताएं ।"
                />
            ),
            placement: "right",
            disableBeacon: true,
            showNext: true,
        },
        {
            target: '[data-tour="session-end-date"]',
            content: (
                <JoyrideContent
                    en="Enter the Academic Session End date."
                    hi="सत्र समाप्त  होने की तिथि बताएं।"
                />
            ),
            placement: "right",
            disableBeacon: true,
            showNext: true,
        },
        {
            target: '[data-tour="term1-start-date"]',
            content: (
                <JoyrideContent
                    en="Enter the start date for Term 1."
                    hi="भाग एक की प्रारंभ तिथि बताएं।"
                />
            ),
            placement: "right",
            disableBeacon: true,
            showNext: true,
        },
        {
            target: '[data-tour="term1-end-date"]',
            content: (
                <JoyrideContent
                    en="Enter the end date for Term 1 ."
                    hi="भाग एक की अंतिम तिथि बताएं।"
                />
            ),
            placement: "right",
            disableBeacon: true,
            showNext: true,
        },
        {
            target: '[data-tour="term2-start-date"]',
            content: (
                <JoyrideContent
                    en="Enter the start date for Term 2 ."
                    hi="भाग दो  की प्रारंभ तिथि बताएं।"
                />
            ),
            placement: "right",
            disableBeacon: true,
            showNext: true,
        },
        {
            target: '[data-tour="term2-end-date"]',
            content: (
                <JoyrideContent
                    en="Enter the end date for Term 2 ."
                    hi="भाग दो की अंतिम तिथि बताएं।"
                />
            ),
            placement: "right",
            disableBeacon: true,
            showNext: true,
        },
        {
            target: '[data-tour="save-session"]',
            content: (
                <JoyrideContent
                    en="Save the Academic Session you created."
                    hi="अकादमिक सत्र जो आपने बनाया है उसको सुरक्षित करे।"
                />
            ),
            placement: "top",
            disableBeacon: true,
            hideFooter: true,
        },
    ];

export const getCelebrationsTourSteps = ({
    dispatch,
    setCelebrationSubTab,
    setShowAddCelebrationForm,
    setActiveTab,
    setTourStage,
    setAwarenessSubTab,

}) => [
        {
            target: '[data-tour="celebrations-proposed-tab"]',
            content: (
                <JoyrideContent
                    en="These are the Proposed Celebrations days, You can choose as per your choice."
                    hi="प्रस्तावित उत्सव और प्रयोजन की सूची आप अपने अनुरूप चुनें ।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
        },
        {
            target: '[data-tour="celebrations-select-list"]',
            content: (
                <JoyrideContent
                    en="Click here to view the list of celebrations."
                    hi="उत्सव और प्रयोजन की सूची देखने के लिए क्लिक करें।"
                />
            ),
            placement: "top",
            disableBeacon: true,
        },
        {
            target: '[data-tour="celebration-checkbox-item"]',
            content: (
                <JoyrideContent
                    en="Select celebrations to add to the academic calendar."
                    hi="अपने ऐकडेमिक कैलेंडर में जोड़ने के लिए उत्सव चुनें।"
                />
            ),
            placement: "right",
            disableBeacon: true,
            spotlightClicks: true,
        },
        {
            target: "body",
            placement: "center",
            disableBeacon: true,
            hideFooter: true,
            disableOverlayClose: true,
            content: (
                <div style={{ textAlign: "center", minWidth: 300 }}>
                    <h6>Do you want to add another celebration?</h6>
                    <p style={{ fontSize: 13, color: "#6b7280" }}>
                        और एक उत्सव जोड़ना चाहते हैं?
                    </p>

                    <div className="d-flex justify-content-center gap-3 mt-3">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                dispatch(setStepIndex(2));
                            }}
                        >
                            Yes / हाँ
                        </button>

                        <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                dispatch(setStepIndex(4));
                            }}
                        >
                            No / नहीं
                        </button>
                    </div>
                </div>
            ),
        },
        {
            target: '[data-tour="celebration-submit-button"]',
            content: (
                <JoyrideContent
                    en="Click here to submit the selected celebrations."
                    hi="चुने हुए उत्सवों को सुरक्षित करें।"
                />
            ),
            placement: "top",
            disableBeacon: true,
            hideFooter: true,
        },
        {
            target: "#celebration-add-custom-anchor",
            placement: "center",
            disableOverlayClose: true,
            hideFooter: true,
            content: (
                <div style={{ textAlign: "center", minWidth: 300 }}>
                    <h6>Do you want to add a custom celebration?</h6>
                    <p style={{ fontSize: 13, color: "#6b7280" }}>
                        क्या आप कस्टम उत्सव जोड़ना चाहते हैं?
                    </p>

                    <div className="d-flex justify-content-center gap-3 mt-3">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                setCelebrationSubTab("custom");
                                setShowAddCelebrationForm(true);

                                // 🔥 Jump DIRECTLY to form steps
                                requestAnimationFrame(() => {
                                    dispatch(setStepIndex(6));
                                });
                            }}
                        >
                            Yes / हाँ
                        </button>

                        <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                dispatch(stopTour());
                                setTourStage("awareness");
                                setActiveTab("awareness");
                                setAwarenessSubTab("select");
                            }}
                        >
                            Skip / नहीं
                        </button>

                    </div>
                </div >
            ),
        },
        {
            target: '[data-tour="celebration-name"]',
            content: (
                <JoyrideContent
                    en="Enter the celebration name."
                    hi="उत्सव का नाम दर्ज करें।"
                />
            ),
            placement: "right",
            disableBeacon: true,
            showNext: true,
        },
        {
            target: '[data-tour="celebration-start-date"]',
            content: (
                <JoyrideContent
                    en="Select the start date for celebration."
                    hi="उत्सव के लिए प्रारंभ तिथि चुनें।"
                />
            ),
            placement: "right",
            showNext: true,
        },
        {
            target: '[data-tour="celebration-end-date"]',
            content: (
                <JoyrideContent
                    en="Select the end date for celebration."
                    hi="उत्सव के लिए अंतिम तिथि चुनें।"
                />
            ),
            placement: "right",
            showNext: true,
        },
        {
            target: '[data-tour="celebration-save"]',
            content: (
                <JoyrideContent
                    en="Save the celebration."
                    hi="उत्सव को कैलेंडर से जोड़ने के लिए यहाँ क्लिक करें। "
                />
            ),
            placement: "top",
            hideFooter: true,

        },
        {
            target: '[data-tour="celebration-list"]',
            content: (
                <JoyrideContent
                    en="The proposed and custom celebrations wil be added here."
                    hi="प्रस्तावित और कस्टम उत्सव यहाँ जोड़े जाएँगे।।"
                />
            ),
            placement: "top",
            disableBeacon: true,
            showNext: true,
            // floaterProps: {
            //     disableFlip: true,
            // },
        },
    ];

export const getAwarenessTourSteps = ({
    dispatch,
    setActiveTab,
    setTourStage,
    setHolidaySubTab,
    setAwarenessSubTab,
    setShowAddAwarenessForm
}) => [
        {
            target: '[data-tour="awareness-proposed-tab"]',
            content: (
                <JoyrideContent
                    en="These are the Proposed awareness days, You can choose as per your choice."
                    hi="ये प्रस्तावित महत्वपूर्ण दिवस हैं। आप अपनी पसंद के अनुसार चयन कर सकते हैं।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
            hideFooter: true,
        },
        {
            target: '[data-tour="awareness-select-list"]',
            content: (
                <JoyrideContent
                    en="Click here to expand and view full list of awareness days."
                    hi="महत्वपूर्ण दिवसों की सूची ।"
                />
            ),
            placement: "top",
            disableBeacon: true,
        },
        {
            target: '[data-tour="celebration-checkbox-item"]',
            content: (
                <JoyrideContent
                    en="Select awareness days you want to add to your Enter the Academic Calendar/ Session."
                    hi="अपने अनुसार महत्वपूर्ण दिवस का चुनाव करें ।"
                />
            ),
            placement: "right",
            disableBeacon: true,
            spotlightClicks: true,
        },
        {
            target: "body",
            placement: "center",
            disableBeacon: true,
            hideFooter: true,
            disableOverlayClose: true,
            content: (
                <div style={{ textAlign: "center", minWidth: 300 }}>
                    <h6>Do you want to add another awareness day?</h6>
                    <p style={{ fontSize: 13, color: "#6b7280" }}>
                        और एक महत्वपूर्ण दिवस जोड़ना चाहते हैं?
                    </p>

                    <div className="d-flex justify-content-center gap-3 mt-3">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                dispatch(setStepIndex(2));
                            }}
                        >
                            Yes / हाँ
                        </button>

                        <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                dispatch(setStepIndex(4));
                            }}
                        >
                            No / नहीं
                        </button>
                    </div>
                </div>
            ),
        },
        {
            target: '[data-tour="celebration-submit-button"]',
            content: (
                <JoyrideContent
                    en="Click here to submit your list of selected Awareness Days."
                    hi="अपने ऐकडेमिक कैलेंडर से चुने हुए महत्वपूर्ण दिवस को जोड़ने के लिए क्लिक करें ।"
                />
            ),
            placement: "top",
            hideFooter: true,
        },
        {
            target: "body",
            placement: "center",
            disableBeacon: true,
            disableOverlayClose: true,
            hideCloseButton: true,
            hideFooter: true,
            content: (
                <div style={{ textAlign: "center", minWidth: 320 }}>
                    <h6 style={{ fontWeight: 600 }}>
                        Do you want to add a custom Awareness Day?
                    </h6>
                    <p style={{ fontSize: 13, color: "#6b7280" }}>
                        क्या आप एक कस्टम महत्वपूर्ण दिवस जोड़ना चाहते हैं?
                    </p>

                    <div className="d-flex justify-content-center gap-3 mt-3">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                console.log("NEXT CLICKED");
                                setAwarenessSubTab("custom");
                                setShowAddAwarenessForm(true);
                                requestAnimationFrame(() => {
                                    dispatch(setStepIndex(6));
                                });
                            }}
                        >
                            Next
                        </button>

                        {/* SKIP */}
                        <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                dispatch(stopTour());
                                setTourStage("holidays");
                                setActiveTab("holidays");
                                setHolidaySubTab("select");
                            }}
                        >
                            Skip
                        </button>
                    </div>
                </div>
            ),
        },
        {
            target: '[data-tour="awareness-name"]',
            content: (
                <JoyrideContent
                    en="Enter the name of awareness day."
                    hi="महत्वपूर्ण दिन का नाम लिखें ।"
                />
            ),
            placement: "right",
            disableBeacon: true,
            showNext: true,
        },
        {
            target: '[data-tour="awareness-start-date"]',
            content: (
                <JoyrideContent
                    en="Select the start date of awareness."
                    hi="महत्वपूर्ण दिवस की प्रारंभ तिथि चुनें।"
                />
            ),
            placement: "right",
            showNext: true,
        },
        {
            target: '[data-tour="awareness-end-date"]',
            content: (
                <JoyrideContent
                    en="Select the end date of awareness."
                    hi="महत्वपूर्ण दिन की अंतिम तिथि चुनें ।"
                />
            ),
            placement: "right",
            showNext: true,
        },
        {
            target: '[data-tour="awareness-save"]',
            content: (
                <JoyrideContent
                    en="Save the awareness day."
                    hi="महत्वपूर्ण जागरूकता दिवस सहेजें।"
                />
            ),
            placement: "top",
            hideFooter: true,

        },
        {
            target: '[data-tour="awareness-list"]',
            content: (
                <JoyrideContent
                    en="The proposed and custom awareness days will be added here."
                    hi="प्रस्तावित व कस्टम महत्वपूर्ण दिन यहाँ जोड़े जाएंगे।"
                />
            ),
            placement: "top",
            disableBeacon: true,
            showNext: true,
        },
    ];

export const getHolidayTourSteps = ({
    dispatch,
    setTourStage,
    setActiveTab,
    setShowAddHolidayForm,
    setHolidaySubTab,
    setCompetitionSubTab,
}
) => [
        {
            target: '[data-tour="holidays-proposed-tab"]',
            content: (
                <JoyrideContent
                    en="These are the Proposed holidays days, You can choose as per your choice."
                    hi="ये प्रस्तावित छुट्टियाँ  हैं। आप अपनी पसंद के अनुसार चयन कर सकते हैं।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
            hideFooter: true,
        },
        {
            target: '[data-tour="holiday-category-list"]',
            content: (
                <JoyrideContent
                    en="These are holiday categories. Expand National, Festival, or Vocational to choose holidays."
                    hi="ये छुट्टियाँ  श्रेणियाँ हैं। राष्ट्रीय, त्योहार या व्यावसायिक श्रेणी खोलकर अवकाश चुनें।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
        },
        {
            target: '[data-tour="holiday-select-checkbox"]',
            content: (
                <JoyrideContent
                    en="Select holidays using these checkboxes."
                    hi="इन चेकबॉक्स का उपयोग करके छुट्टियाँ  चुनें।"
                />
            ),
            placement: "top",
            disableBeacon: true,
        },
        {
            target: "body",
            placement: "center",
            disableBeacon: true,
            hideFooter: true,
            disableOverlayClose: true,
            content: (
                <div style={{ textAlign: "center", minWidth: 300 }}>
                    <h6>Do you want to add another holiday?</h6>
                    <p style={{ fontSize: 13, color: "#6b7280" }}>
                        और एक छुट्टियाँ  जोड़ना चाहते हैं?
                    </p>

                    <div className="d-flex justify-content-center gap-3 mt-3">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                dispatch(setStepIndex(2));
                            }}
                        >
                            Yes / हाँ
                        </button>

                        <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                dispatch(setStepIndex(4));
                            }}
                        >
                            No / नहीं
                        </button>
                    </div>
                </div>
            ),
        },
        {
            target: '[data-tour="holiday-submit-button"]',
            content: (
                <JoyrideContent
                    en="Click here to choose and submit the selected holidays."
                    hi="चयनित छुट्टियाँ कैलेंडर से जोड़ने के लिए यहाँ क्लिक करें।"
                />
            ),
            placement: "top",
            hideFooter: true,
            floaterProps: {
                disableAnimation: true,
            }
        },
        {
            target: "body",
            placement: "center",
            disableBeacon: true,
            disableOverlayClose: true,
            hideCloseButton: true,
            content: (
                <div style={{ textAlign: "center", minWidth: 320 }}>
                    <h6 style={{ fontWeight: 600 }}>
                        Do you want to add a custom Holiday?
                    </h6>
                    <p style={{ fontSize: 13, color: "#6b7280" }}>
                        क्या आप एक कस्टम छुट्टियाँ जोड़ना चाहते हैं?
                    </p>

                    <div className="d-flex justify-content-center gap-3 mt-3">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                setHolidaySubTab("custom");
                                setShowAddHolidayForm(true);
                                setTimeout(() => {
                                    dispatch(setStepIndex(6));
                                }, 0);
                            }}
                        >
                            Next
                        </button>

                        <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                dispatch(stopTour());
                                setTourStage("competitions");
                                setActiveTab("competitions");
                                setCompetitionSubTab("checkboxList");
                            }}
                        >
                            Skip
                        </button>
                    </div>
                </div>
            ),
        },
        {
            target: '[data-tour="holiday-name"]',
            content: (
                <JoyrideContent
                    en="Enter the holiday name"
                    hi="छुट्टी का नाम लिखें।"
                />
            ),
            placement: "right",
            disableBeacon: true,
            showNext: true,
        },
        {
            target: '[data-tour="holiday-category"]',
            content: (
                <JoyrideContent
                    en="Choose the holiday cateory."
                    hi="छुट्टी की श्रेणी चुनें।"
                />
            ),
            placement: "right",
            showNext: true,
        },
        {
            target: '[data-tour="holiday-start-date"]',
            content: (
                <JoyrideContent
                    en="Select the start date of holiday."
                    hi="छुट्टी की प्रारंभ तिथि चुनें।"
                />
            ),
            placement: "right",
            showNext: true,
        },
        {
            target: '[data-tour="holiday-end-date"]',
            content: (
                <JoyrideContent
                    en="Select the end date of holiday."
                    hi="छुट्टी की अंतिम तिथि चुनें।"
                />
            ),
            placement: "right",
            showNext: true,
        },
        {
            target: '[data-tour="holiday-save"]',
            content: (
                <JoyrideContent
                    en="Save the holiday."
                    hi="छुट्टी सहेजें।"
                />
            ),
            placement: "top",
            hideFooter: true,

        },
        {
            target: '[data-tour="holidays-list"]',
            content: (
                <JoyrideContent
                    en="The proposed and custom holidays will be added here."
                    hi="प्रस्तावित व कस्टम अवकाश यहाँ जोड़े जाएंगे।"
                />
            ),
            placement: "top",
            disableBeacon: true,
            showNext: true,
            // floaterProps: {
            //     disableFlip: true,
            // },
        },
    ]

export const getCompetitionTourSteps = ({
    dispatch,
    setShowAddCompetitionForm,
    setCompetitionSubTab,
    setTourStage,
    setActiveTab,
    setExamSubTab,
}) => [
        {
            target: '[data-tour="competition-proposed-tab"]',
            content: (
                <JoyrideContent
                    en="These are the Proposed competitions, You can choose as per your choice."
                    hi="ये प्रस्तावित प्रतियोगिताएँ हैं। आप अपनी पसंद के अनुसार चयन कर सकते हैं।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
            hideFooter: true,
        },
        {
            target: '[data-tour="competition-category-list"]',
            content: (
                <JoyrideContent
                    en="Select competitions from this category."
                    hi="इस श्रेणी से प्रतियोगिताएँ चुनें।।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
        },
        {
            target: '[data-tour="competition-select-checkbox"]',
            content: (
                <JoyrideContent
                    en="Select competition using these checkboxes."
                    hi="इन चेकबॉक्स का उपयोग करके प्रतियोगिता चुनें।"
                />
            ),
            placement: "right",
            disableBeacon: true,
        },
        {
            target: "body",
            placement: "center",
            disableBeacon: true,
            hideFooter: true,
            disableOverlayClose: true,
            content: (
                <div style={{ textAlign: "center", minWidth: 300 }}>
                    <h6>Do you want to add another competition?</h6>
                    <p style={{ fontSize: 13, color: "#6b7280" }}>
                        और एक प्रतियोगिता जोड़ना चाहते हैं?
                    </p>

                    <div className="d-flex justify-content-center gap-3 mt-3">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                dispatch(setStepIndex(2));
                            }}
                        >
                            Yes / हाँ
                        </button>

                        <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                dispatch(setStepIndex(4));
                            }}
                        >
                            No / नहीं
                        </button>
                    </div>
                </div>
            ),
        },
        {
            target: '[data-tour="competition-submit-button"]',
            content: (
                <JoyrideContent
                    en="Submit the selected competitions."
                    hi="कैलेंडर से जोड़ने के लिए यहाँ क्लिक करें। "
                />
            ),
            placement: "top",
            hideFooter: true,
            floaterProps: {
                disableAnimation: true,
            }
        },
        {
            target: "body",
            placement: "center",
            disableBeacon: true,
            disableOverlayClose: true,
            hideCloseButton: true,
            content: (
                <div style={{ textAlign: "center", minWidth: 320 }}>
                    <h6 style={{ fontWeight: 600 }}>
                        Do you want to add a custom Competition?
                    </h6>
                    <p style={{ fontSize: 13, color: "#6b7280" }}>
                        क्या आप एक कस्टम प्रतियोगिता जोड़ना चाहते हैं?
                    </p>

                    <div className="d-flex justify-content-center gap-3 mt-3">
                        {/* NEXT */}
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                setCompetitionSubTab("addForm");
                                setShowAddCompetitionForm(true);

                                // Move tour forward if needed
                                setTimeout(() => {
                                    dispatch(setStepIndex(6)); // next logical step
                                }, 0);
                            }}
                        >
                            Next
                        </button>

                        {/* SKIP */}
                        <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                dispatch(stopTour());
                                setTourStage("exams");
                                setActiveTab("exams");
                                setExamSubTab("checkboxList");
                            }}
                        >
                            Skip
                        </button>
                    </div>
                </div>
            ),
        },
        //6
        {
            target: '[data-tour="competition-name"]',
            content: (
                <JoyrideContent
                    en="Enter the competition name."
                    hi="प्रतियोगिता का नाम लिखें। "
                />
            ),
            placement: "right",
            disableBeacon: true,
            showNext: true,
        },
        //7
        {
            target: '[data-tour="competition-category"]',
            content: (
                <JoyrideContent
                    en="Select the competition category."
                    hi="प्रतियोगिता की श्रेणी चुनें। "
                />
            ),
            placement: "right",
            showNext: true,
        },
        //8
        {
            target: '[data-tour="competition-start-date"]',
            content: (
                <JoyrideContent
                    en="Select the competition start date."
                    hi="प्रतियोगिता की प्रारंभ तिथि चुनें। "
                />
            ),
            placement: "right",
            showNext: true,
        },
        //9
        {
            target: '[data-tour="competition-end-date"]',
            content: (
                <JoyrideContent
                    en="Select the competition end date."
                    hi="प्रतियोगिता की अंतिम तिथि चुनें। "
                />
            ),
            placement: "right",
            showNext: true,
        },
        //10
        {
            target: '[data-tour="competition-save"]',
            content: (
                <JoyrideContent
                    en="Save the competition."
                    hi="प्रतियोगिता सहेजें। "
                />
            ),
            placement: "top",
            hideFooter: true,

        },
        //11
        {
            target: '[data-tour="competition-list"]',
            content: (
                <JoyrideContent
                    en="The proposed and custom competition will be added here."
                    hi="प्रस्तावित और कस्टम प्रतियोगिताएँ यहाँ जोड़ी जाएँगी।।"
                />
            ),
            placement: "top",
            disableBeacon: true,
            showNext: true,
            floaterProps: {
                disableFlip: true,
            },
        },
    ]


export const getExamTourSteps = ({
    dispatch,
    setExamSubTab,
    setShowAddExamForm,
    setTourStage,
    setActiveTab,
}) => [
        {
            target: '[data-tour="exam-select-tab"]',
            content: (
                <JoyrideContent
                    en="Here you can select exams to add.."
                    hi="यहाँ से आप विभिन्न प्रकार की परीक्षाएँ चुनकर लिस्ट बना सकते हैं।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
            hideFooter: true,
        },
        {
            target: '[data-tour="exam-category-list"]',
            content: (
                <JoyrideContent
                    en="Select exams from this category."
                    hi="दी हुई श्रेणी के अनुसार परीक्षाएँ चुनें।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
        },
        {
            target: '[data-tour="add-exam-btn"]',
            content: (
                <JoyrideContent
                    en="Click here to add exams under this category."
                    hi="इस श्रेणी के अंतर्गत परीक्षाएँ जोड़ने के लिए यहाँ क्लिक करें।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
        },
        {
            target: '[data-tour="start-date"]',
            content: (
                <JoyrideContent
                    en="Select the proposed exam start date"
                    hi="परीक्षा की प्रस्तावित प्रारंभ तिथि बताएं।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
            showNext: true,
        },
        {
            target: '[data-tour="end-date"]',
            content: (
                <JoyrideContent
                    en="Select the proposed exam end date."
                    hi="परीक्षा की प्रस्तावित समाप्ति तिथि बताएं।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
            showNext: true,
        },
        {
            target: '[data-tour="proposed-exam-details"]',
            content: (
                <JoyrideContent
                    en="Enter the exam details here."
                    hi="यहाँ परीक्षा का विवरण लिखें ।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
            showNext: true
        },
        {
            target: '[data-tour="exam-checkbox"]',
            content: (
                <JoyrideContent
                    en="Select the exam to include it."
                    hi="इस परीक्षा को शामिल करने के लिए इसे चुनें।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
        },
        {
            target: '[data-tour="exam-submit"]',
            content: (
                <JoyrideContent
                    en="Submit the selected exams"
                    hi="चयनित परीक्षाएँ अकादमिक सत्र जोड़ने के लिए क्लिक करें ।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
        },
        {
            target: "body",
            placement: "center",
            disableBeacon: true,
            disableOverlayClose: true,
            hideCloseButton: true,
            content: (
                <div style={{ textAlign: "center", minWidth: 320 }}>
                    <h6 style={{ fontWeight: 600 }}>
                        Do you want to add a custom exam?
                    </h6>
                    <p style={{ fontSize: 13, color: "#6b7280" }}>
                        क्या आप एक कस्टम परीक्षा जोड़ना चाहते हैं?
                    </p>

                    <div className="d-flex justify-content-center gap-3 mt-3">
                        {/* NEXT */}
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                setExamSubTab("addForm");
                                setShowAddExamForm(true);

                                // Move tour forward if needed
                                setTimeout(() => {
                                    dispatch(setStepIndex(9)); // next logical step
                                }, 0);
                            }}
                        >
                            Next
                        </button>

                        {/* SKIP */}
                        <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                dispatch(stopTour());
                                setTourStage("ptms");
                                setActiveTab("ptms");
                            }}
                        >
                            Skip
                        </button>
                    </div>
                </div>
            ),
        },
        //9
        {
            target: '[data-tour="exam-name"]',
            content: (
                <JoyrideContent
                    en="Enter the exam name."
                    hi="परीक्षा का नाम लिखें।"
                />
            ),
            placement: "right",
            disableBeacon: true,
            showNext: true,
        },
        //10
        {
            target: '[data-tour="exam-category"]',
            content: (
                <JoyrideContent
                    en="Choose the exam category."
                    hi="परीक्षा की श्रेणी चुनें।"
                />
            ),
            placement: "right",
            showNext: true,
        },
        //11
        {
            target: '[data-tour="exam-start-date"]',
            content: (
                <JoyrideContent
                    en="Select the exam start date."
                    hi="परीक्षा की प्रारंभ तिथि चुनें ।"
                />
            ),
            placement: "right",
            showNext: true,
        },
        //12
        {
            target: '[data-tour="exam-end-date"]',
            content: (
                <JoyrideContent
                    en="Select the exam end date."
                    hi="परीक्षा की अंतिम तिथि चुनें।"
                />
            ),
            placement: "right",
            showNext: true,
        },
        //13
        {
            target: '[data-tour="exam-save"]',
            content: (
                <JoyrideContent
                    en="Save the exam."
                    hi="परीक्षा सहेजें।"
                />
            ),
            placement: "top",
            hideFooter: true,

        },
        //14
        {
            target: '[data-tour="exam-list"]',
            content: (
                <JoyrideContent
                    en="The select and custom exams will be added here."
                    hi="आपके जागरूकता दिवस यहाँ जोड़े जाएँगे।"
                />
            ),
            placement: "top",
            disableBeacon: true,
            showNext: true,
            floaterProps: {
                disableFlip: true,
            },
        },
    ]

export const getPtmTourSteps = () => [
    {
        target: '[data-tour="ptm-add-btn"]',
        content: (
            <JoyrideContent
                en="Add a Parent Teacher Meeting."
                hi="पैरेंट टीचर मीटिंग के विवरण के लिए यहाँ क्लिक करें।"
            />
        ),
        placement: "bottom",
        disableBeacon: true,
    },
    {
        target: '[data-tour="ptm-name"]',
        content: (
            <JoyrideContent
                en="Enter the Parent Teacher Meeting name."
                hi="पैरेंट टीचर मीटिंग का नाम बताएं ।"
            />
        ),
        placement: "right",
        disableBeacon: true,
        showNext: true,
    },
    {
        target: '[data-tour="ptm-start-date"]',
        content: (
            <JoyrideContent
                en="Select From the PTM Date and Time Start."
                hi="पैरेंट टीचर मीटिंग की प्रारंभ तिथि और समय बताएं ।"
            />
        ),
        placement: "right",
        showNext: true,
    },
    {
        target: '[data-tour="ptm-end-date"]',
        content: (
            <JoyrideContent
                en="Select From the PTM Date and Time end."
                hi=" पैरेंट टीचर मीटिंग की समाप्ति की तिथि और समय बताएं।"
            />
        ),
        placement: "right",
        showNext: true,
    },
    {
        target: '[data-tour="ptm-save"]',
        content: (
            <JoyrideContent
                en="Save the Parent teacher Meeting"
                hi="पैरेंट टीचर को कैलेंडर से जोड़ने के लिए यहाँ क्लिक करें। "
            />
        ),
        placement: "top",
        hideFooter: true,

    },
    {
        target: '[data-tour="ptm-list"]',
        content: (
            <JoyrideContent
                en="The ptm list will be shown here."
                hi="पैरेंट टीचर की सूची यहाँ दिखाई जाएगी। "
            />
        ),
        placement: "top",
        hideFooter: true,
        showNext: true,
        floaterProps: {
            disableFlip: true,
        },
    },
]

export const getCalendarSteps = () => [
    {
        target: '[data-tour="view-calendar"]',
        content: (
            <JoyrideContent
                en="This is the academic calendar showing all important school activities."
                hi="यह शैक्षणिक कैलेंडर है, जिसमें स्कूल की सभी महत्वपूर्ण गतिविधियाँ दिखाई जाती हैं।"
            />
        ),
        placement: "top",
        hideFooter: true,
        disableBeacon: true,
        isFinalStep: true,
        floaterProps: {
            disableFlip: true,
        },
    },
]